import React, { createContext, useContext, useState } from 'react';
import { User } from '@shared/types';

interface UserContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  isLoadingUser: boolean;
  setIsLoadingUser: (isLoading: boolean) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoadingUser, setIsLoadingUser] = useState(true);

  return (
    <UserContext.Provider value={{ user, setUser, isLoadingUser, setIsLoadingUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};